<template>
  <div>
    <div v-if="Object.keys(wltpValues).length > 0" class="uk-text-small">
      WLTP:
      <p v-html="valueList"></p>
    </div>
    <div v-else class="uk-grid uk-child-width-1-1 uk-text-light uk-text-small uk-grid-small">
      <div v-if="vehicle.emissioncom > 0" class="uk-flex uk-flex-middle">
        {{ vehicle.emissioncom | number }} l/100km (komb.)
      </div>
      <div class="uk-flex uk-flex-middle" v-if="vehicle.powerconsumptioncom > 0">
        <span>
          {{ vehicle.powerconsumptioncom | number }} kWh/100km (komb.)
        </span>
      </div>
      <div v-if="vehicle.emission > 0" class="uk-flex uk-flex-middle">
        {{ vehicle.emission | number }} g CO<sub class="uk-padding-remove">2</sub>/km (komb.)
      </div>
      <div v-if="vehicle.co2efficiencyclass">
        CO<sub class="uk-padding-remove">2</sub>-Klasse: {{ vehicle.co2efficiencyclass }}
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: ['vehicle', 'settings'],
  computed: {
    wltpValues() {
      return { ...this.vehicle.wltpConsumptions, ...this.vehicle.wltpEmissions }
    },
    valueList() {
      const data = []

      if ('fuelCombined' in this.wltpValues &&
        'fuelCombinedWeighted' in this.wltpValues &&
        'powerCombinedWeighted' in this.wltpValues &&
        'co2EmissionCombinedWeighted' in this.wltpValues &&
        'co2EfficiencyClassWeighted' in this.wltpValues &&
        'co2EfficiencyClass' in this.wltpValues
      ) {

        data.push(
          this.numberFormat(this.wltpValues.powerCombinedWeighted) + ' kWh/100 km + ' +
          this.numberFormat(this.wltpValues.fuelCombinedWeighted) + ' l/100 km (gew. komb.), ' +
          this.numberFormat(this.wltpValues.fuelCombined) + ' l/100 km (entladen, komb.)'
        )
        data.push(
          this.numberFormat(this.wltpValues.co2EmissionCombinedWeighted) + ' g CO<sub class="uk-padding-remove">2</sub>/km (gew. komb.)'
        )
        data.push('CO<sub class="uk-padding-remove">2</sub>-Klasse ' + 
          this.wltpValues.co2EfficiencyClassWeighted + ' (gew. komb.), ' +
					this.wltpValues.co2EfficiencyClass + ' (entladen, komb.)'
        )
      } else {
        for (const [key, value] of Object.entries(this.wltpValues)) {
          if (key === 'fuelCombined') {
            data.push(this.numberFormat(value) + ' l/100 km (komb.)')
          }
          if (key === 'powerCombined') {
            data.push(this.numberFormat(value) + ' kWh/100 km (komb.)')
          }
          if (key === 'co2EmissionCombined') {
            data.push(this.numberFormat(value) + ' g CO<sub class="uk-padding-remove">2</sub>/km (komb.)')
          }
          if (key === 'co2EfficiencyClass' || key == 'co2ElectricEfficiencyClass') {
            data.push('CO<sub class="uk-padding-remove">2</sub>-Klasse ' + value + ' (komb.)')
          }
        }
      }

      return data.join(' <br> ')
    }
  },
  methods: {
    numberFormat(value) {
      const nf = new Intl.NumberFormat(['de-DE']);
      return nf.format(value);
    },
  }
}
</script>